import {
  Box,
  HtmlButtonProps,
  IconButton,
  IconNames,
  Tooltip,
} from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { forwardRef, ReactNode } from 'react';

import styles from './topbarButtonOld.module.scss';

type TopbarButtonOldProps = {
  className?: string;
  icon: IconNames;
  showSpinner?: boolean;
  tooltip?: ReactNode;
  showNotificationIndicator?: boolean;
  notificationIndicatorTooltip?: string;
  notificationIndicatorClassName?: string;
} & HtmlButtonProps;

export const TopbarButtonOld = forwardRef<
  HTMLButtonElement,
  TopbarButtonOldProps
>(function TopbarButtonOld(
  {
    className,
    showSpinner,
    icon,
    tooltip,
    showNotificationIndicator,
    notificationIndicatorTooltip,
    notificationIndicatorClassName,
    ...otherProps
  },
  ref,
) {
  const rootClass = classnames(
    {
      [styles.root]: styles.root,
    },
    className,
  );

  const notificationIndicator = classnames(
    {
      [styles.notificationIndicator]: styles.notificationIndicator,
    },
    notificationIndicatorClassName,
  );

  return (
    <Tooltip disabled={!tooltip} content={tooltip} wrap="div">
      <Box className={styles.notificationWrapper}>
        <IconButton
          ref={ref}
          isLoading={showSpinner}
          icon={icon}
          variant="secondary"
          {...otherProps}
          className={rootClass}
        />
        {showNotificationIndicator && (
          <Tooltip
            disabled={!notificationIndicatorTooltip}
            content={notificationIndicatorTooltip}
          >
            {showNotificationIndicator && (
              <div className={notificationIndicator} />
            )}
          </Tooltip>
        )}
      </Box>
    </Tooltip>
  );
});
